import React, { Component } from 'react'
import { MDBContainer,  MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,  
    MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBDataTable, MDBInput, MDBTooltip,Button, MDBCardGroup, MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText, } from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Card, Input   } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import {  MDBRow, MDBCol } from "mdbreact";
import Modalsentedit from './Modalsentedit';
import Modalshowroom from './Modalshowroom';



export default class Buildingreportlist extends Component {

    constructor(props) {
        super(props);
        this.state = {
          articlesci1:[],
          emp:[],
          term:'',
          empcouncil:[],
          classroom:[],
          building:[],
          modal: false,
          idExpert:'',
         
          idemp:'',
          citizen_id:'',
          employee_name:'',
          type:'2',
          search: '',
          research: [],
          loading:false,

          id_room:'',
          name_room:'',
          type_room:'-',
          building_name:'-',
          amount:'',
          building_id:'',
          building_location:'',
          



        };
        this.handleChange = this.handleChange.bind(this);

        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.getthcouncil = this.getthcouncil.bind(this);
        this.getclassroom = this.getclassroom.bind(this);
        this.updateSearch = this.updateSearch.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.showroom = this.showroom.bind(this);
        this.updateSearchDepartment = this.updateSearchDepartment.bind(this);
        this.linkto = this.linkto.bind(this);
        
      }


      componentDidMount() {
        const { id } = this.props.match.params
      
        this.setState({ building_id :  id })
        this.setState({ loading: true})
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getclassroomwherebuilding/'+id)
              // Axios.get('https://research.kpru.ac.th/Api_Research/index/research_search')
           .then(res => {
          //    console.log(res.data);
          if ( res.data.length > 0) {
            this.setState({ building_location: res.data[0].building_location})
          }
             
           //  this.setState({ bankname: res.data, loading: false })
              this.setState({ building: res.data})
              this.setState({ loading: false})
           }) 
         }, 0);

      }

      onTextChange = (e) => {

        this.setState({ [e.target.name]: e.target.value })
      }

      getclassroom() {

        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getclassroom')
              // Axios.get('https://research.kpru.ac.th/Api_Research/index/research_search')
           .then(res => {
           //  console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ classroom: res.data})
           
           }) 
         }, 0);

      }


      getthcouncil() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncil/2/'+this.state.term)
           .then(res => {
          //   console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ empcouncil: res.data})
           }) 
         }, 0);
      }

      updateSearch(event) {
        this.setState({ search: event.target.value.substr(0, 20) });
      
    }

    updateSearchDepartment(value) {
        // console.log(event.target.value)
        // const term = event.target.value;
        const term = value;
        this.setState({ term });
        //    setTimeout(() => {
        //      this.getthschedule1()
        //    }, 500);
    }


     toggle = () => {
      this.setState({
        modal: !this.state.modal,
        id_room:'',
        name_room:'',
        type_room:'-',
        building_name:'-',
        amount:'',
      });
    }

    handleChange(event) {    this.setState({idExpert: event.target.value});  }

    
    onChange(value) {
        //  console.log(`selected ${value}`);
     // Axios.get('https://mua.kpru.ac.th/FrontEnd_Mis/employee/procSEmpInfo/'+value)
      //  .then(res => {
         // console.log(res.data.procSEmpInfo[0].citizen_id);
        //  this.setState({ bankname: res.data, loading: false })
       //   this.setState({ citizen_id: res.data.procSEmpInfo[0].citizen_id})
       //   this.setState({ idemp: res.data.procSEmpInfo[0].employee_id})
       //   this.setState({ employee_name: res.data.procSEmpInfo[0].employee_name})
      //  })
         //  const idemp = value;
         //  this.setState({ idemp });
    }
    
     onBlur() {
      console.log('blur');
    }
    
     onFocus() {
      console.log('focus');
    }
    
     onSearch(val) {
      console.log('search:', val);
    }

    linkto() {
        setTimeout(() => {
         // window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tesslearn.php?term='+this.state.term+'&idemp='+this.state.major+'', '_blank');
           //  window.open('http://localhost/tesspdf/TCPDF-main/tesslearn.php?term='+this.state.term+'&idemp='+this.state.major+'', '_blank');
            window.location.href ='/tess/Buildingreport'
         }, 0);
      }

    handleSubmit () {
        
        const dataadd = new FormData();
        dataadd.append("id_room", this.state.id_room);
        dataadd.append("name_room", this.state.name_room);
        dataadd.append("type_room", this.state.type_room);
        dataadd.append("building_name", this.state.building_name);
        dataadd.append("amount", this.state.amount);
      
        Axios.post('https://git.kpru.ac.th/FrontEnd_Tabian/load/Addroom/',dataadd)
       
        .then(res => {
        //    console.log(res);
            if (res.status === 200) {
            //  alert("บันทึกสำเร็จ")
                      Swal.fire({
                          title: 'บันทึกข้อมูลสำเร็จ',
                          //text: 'มหาวิทยาลัยราชภัฏกำแพงเพชรขอขอบคุณ',
                          icon: 'success',
                        // showCancelButton: true,
                          confirmButtonText: 'ตกลง',
                        // cancelButtonText: 'No, keep it'
                        }).then((result) => {
                        
                        })
                     }
                })
             this.toggle()
             this.getclassroom()

      }

      showroom = (id) => { //เมื่อมีการคลิกลบ ฟังก์ชั่นนี้จะถูกเรียกใช้งาน แล้วส่ง id ที่ต้องการลบไปที่ไฟล์ delete.php
        //  console.log("dfdf")
            //   setTimeout(() => {
            //      console.log(id)
            //      window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+id, '_blank');
               
                
            //    }, 1000); 

        }



    render() {
     //   console.log(this.state.classroom)
     console.log(this.state.id_room)
     console.log(this.state.name_room)
     console.log(this.state.amount)

        const { Option } = Select;
        
        let filteredPage = this.state.building.filter(
            (building) => {
              return (building.building_name.indexOf(this.state.search) !== -1) 
            }
          )

        //   const persons = !data ?  <h2>loading...</h2>:<MDBDataTable
        //     searching ={false}
        //     striped
        //     bordered
        //     hover
        //     data={data}
        //     entriesLabel="จำนวนที่แสดง "
        //     infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}

        //     responsive 
        //     />

         //ชุดตาราง
         const data = {
          columns: [
            {
              label: '#',
              field: 'list',
              sort: 'list',
              width: 150
            },
           
            {
              label: 'หมายเลขห้อง',
              field: 'building_code',
              sort: 'building_code',
              width: 270
            },
            {
              label: 'ชื่ออาคาร',
              field: 'building_name',
              sort: 'building_name',
              width: 200
            }


          ],

          rows: [...filteredPage.map((data, i) => (
            {
               list: <>{i+1}</>,
               building_code: <>{data.name_room}</>,
               building_name: <>{data.buildingname}<br/>
               {this.state.term === ''?<></>:<>
                <Modalshowroom id_room={data.id_room} team={this.state.term} />
               </>}
              
               </>

            }
           ))]
      
      };

      const persons = <MDBDataTable
       searching ={true}
       searchLabel="ค้นหาชื่อห้อง"
       striped
       bordered
       small 
       entries={20}
      // entriesOptions={["10", "20"]}
       order={["age", "desc"]}
       data={data}
       entriesLabel="จำนวนที่แสดง "
       infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
       paginationLabel={["ย้อนกลับ", "ถัดไป"]}
       responsive 
       sortRows={['random']}
       />


        return (
        <MDBContainer  fluid>
          <Card type="inner"  title={<h4><MDBIcon icon="city" /> การใช้อาคารเรียน</h4>} >
            <br/>
             {/* <h5 className="text-center">ข้อมูลห้องเรียน</h5>  */}
          
          {this.state.loading === true ? <>
            <MDBRow>
        <MDBCol></MDBCol>
        <MDBCol className="text-center">
            <div className="spinner-border text-primary" role="status">
            <span className="sr-only text-center">Loading...</span>
            </div>
        </MDBCol>
        <MDBCol></MDBCol>
      </MDBRow>
            
            </>: <>

            {/* <MDBRow>
                <MDBCol size="6"> <MDBInput className="d-flex justify-content-end" label="ค้นหาชื่ออาคาร"  style={{ width: '50%' }}  onChange={this.updateSearch.bind(this)} icon="user"  /> </MDBCol>
              
            </MDBRow> */}

        <MDBRow>
           
           <MDBCol sm="4">
             <p>เลือกภาคเรียน</p>
               <div>
                   <CaretDownOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />   
                       <Select
                           showSearch
                           style={{ width: 300 }}
                           placeholder="เลือกเทอม"
                           optionFilterProp="children"
                           onChange={this.updateSearchDepartment}
                           onFocus={this.onFocus}
                           onBlur={this.onBlur}
                           value={this.state.term}
                           onSearch={this.onSearch}
                           filterOption={(input, option) =>
                               option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                           }
                       >
                           <Option value="3/2563">3/2563</Option>
                           <Option value="1/2564">1/2564</Option>
                           <Option value="2/2564">2/2564</Option>
                           <Option value="3/2564">3/2564</Option>
                           <Option value="1/2565">1/2565</Option>
                           <Option value="2/2565">2/2565</Option>
                           <Option value="3/2565">3/2565</Option>
                           <Option value="1/2566">1/2566</Option>
                           <Option value="2/2566">2/2566</Option>
                           <Option value="3/2566">3/2566</Option>
                           <Option value="1/2567">1/2567</Option>
                           <Option value="2/2567">2/2567</Option>
                           <Option value="3/2567">3/2567</Option>
                           <Option value="1/2568">1/2568</Option>
                           <Option value="2/2568">2/2568</Option>
                           <Option value="3/2568">3/2568</Option>

                       </Select>
                   </div>
                   {/* <br/> */}

           </MDBCol>
           
           <MDBCol sm="8" className='text-right'>
           <MDBBtn color="blue-grey" size='sm' onClick={this.linkto}><MDBIcon icon="caret-left" /> กลับหน้าหลัก</MDBBtn>
           </MDBCol>

        </MDBRow><br/>

            {persons}

              {this.state.building_location !== '' ?<>
                 <iframe src={this.state.building_location} width="100%" height="550"></iframe>
              </>:<>
                  ไม่ได้ระบุตำแหน่ง
              </>}
           
            <MDBRow >
             

            </MDBRow>

            </> }
            {/* <p>หมายเหตุ : ข้อมูลใช้ประกอบการจัดตารางสอน ไม่ให้ชนกับการประชุม</p> */}
     
        
            </Card>
        </MDBContainer>
        
        )
    }
}
